<template>
    <div>
        <headline>
            Konferenzraum Buchungen
            <template slot="more">
                <monthspicker @date="load" :date="current" class="mr-2"></monthspicker>

                <button-secondary @click="download">
                    <template slot="icon"><i class="fa fa-download"></i></template> Daten exportieren
                </button-secondary>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div class="" v-show="!loading">
            <div>

                <accordion>
                    <accordion-item v-for="(foo, day) in schedules" :key="day" :id="day">
                        <template v-slot:header>
                            <span :class="{'text-primary': asDay(day) === asDay(today) }">{{ asDay(day) }}</span>
                            <span class="font-bold">{{ schedules[day].length }} Buchungen</span>
                        </template>

                        <p class="p-4" v-show="schedules[day].length === 0">
                            Keine Buchungen an diesem Tag gefunden.
                        </p>

                        <tailwind-table :header="['User', 'Name', 'Etage', 'Zeitraum','Ersteller','Anmerkungen', 'Serienbuchung', '']" v-show="schedules[day] && schedules[day].length > 0">
                            <tr v-for="(schedule, i) in schedules[day]" :class="{'bg-gray-50': i%2}">
                                <td class="px-6 py-3">
                                    <span v-if="schedule.user">{{ schedule.user.first_name }} {{ schedule.user.name }}</span>
                                    <span v-show="schedule.user_id && !schedule.user">gelöschter User</span>
                                </td>
                                <td class="px-6 py-3">
                                    <span v-if="schedule.conference_room.name">{{ schedule.conference_room.name }}</span>
                                </td>
                                <td class="px-6 py-3">
                                    <floor-item :item="schedule.conference_room.floor"></floor-item>
                                </td>
                                <td class="px-6 py-3">
                                    {{ time(schedule.start) }} - {{ time(schedule.end) }}
                                </td>
                                <td class="px-6 py-3">
                                    {{ schedule.created_by?.first_name }} {{ schedule.created_by?.name }}
                                    <span v-show="schedule.source"
                                        class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-gray-100 text-pink-800">
                                        {{ schedule.source }}
                                    </span>
                                </td>
                                <td class="px-6 py-3">
                                    {{ schedule.comment }}
                                    <span v-show="schedule.event?.title" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Veranstaltungstitel</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ schedule.event?.title }}
                                        </span>
                                    </span>
                                    <span v-if="schedule.room_layout" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Raumlayout</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ schedule.room_layout.name }}
                                        </span>
                                    </span>
                                    <span v-if="schedule.caterings.length" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Catering</span><br>
                                       <span v-for="catering in schedule.caterings"
                                             class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                                      {{ catering.name }}
                                       </span>
                                    </span>
                                    <span v-show="schedule.postable_equipment.length > 0" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Zubuchbares Equipment</span><br>
                                        <span v-for="equipment in schedule.postable_equipment"
                                              class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ equipment.name }}
                                        </span>
                                    </span>
                                    <span v-show="schedule.event?.person" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Teilnehmeranzahl</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ schedule.event?.person }}
                                        </span>
                                    </span>
                                    <span v-show="schedule.event?.phone" class="text-gray-500">
                                        <br><span class="text-sm font-medium text-gray-500">Rufnummer für Rückfragen</span><br>
                                        <span
                                            class="mr-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-gray-800">
                                            {{ schedule.event?.phone }}
                                        </span>
                                    </span>
                                </td>
                                <td class="px-6 py-3">
                                    <span v-if="schedule.conference_room_booking_series"> {{schedule.conference_room_booking_series.begin | DATE}} - {{schedule.conference_room_booking_series.end | DATE}} Frequenz: {{schedule.conference_room_booking_series.cycle}} {{getReadableInterval(schedule.conference_room_booking_series.type)}}</span>
                                </td>
                                <td class="px-6 py-3 text-right flex" v-if="can.update.conference_room_booking && new Date(schedule.start) >= (new Date()).setHours(0,0,0,0)">

                                    <conference-room-booking-edit @changed="load" :booking="schedule" :floors="floors"></conference-room-booking-edit>
                                    <conference-room-booking-delete @deleted="load" :booking="schedule" ></conference-room-booking-delete>
                                    <conference-room-custom-email  class="ml-5" :booking="schedule"></conference-room-custom-email>
                                </td>
                            </tr>
                        </tailwind-table>
                    </accordion-item>
                </accordion>


            </div>

            <p class="p-4" v-show="schedules.length === 0">
                Keine Buchungen in diesem Monat gefunden.
            </p>
        </div>

    </div>
</template>

<script>
import ButtonSecondary from "../components/UI/ButtonSecondary";
import Headline from "../components/UI/Headline";
import Monthspicker from "../components/Monthspicker";
import TailwindTable from "../components/UI/TailwindTable";
import ConfirmDialog from "../components/UI/ConfirmDialog";
import ButtonDelete from "../components/UI/ButtonDelete";
import Loading from "../components/UI/Loading";
import Accordion from "../components/UI/Accordion";
import AccordionItem from "../components/UI/AccordionItem";
import DeskItem from "../components/DeskItem.vue";
import format from "date-fns/format"
import FloorItem from "../components/FloorItem.vue";
import ButtonPrimary from "../components/UI/ButtonPrimary.vue";
import ConferenceRoomBookingEdit from "../components/ConferenceRoomBookingEdit.vue";
import ConferenceRoomBookingDelete from "../components/ConferenceRoomBookingDelete.vue";
import ConferenceRoomCustomEmail from "../components/ConferenceRoomCustomEmail.vue";

export default {
    name: "ConferenceRoomSchedules",
    components: {
        ConferenceRoomCustomEmail,
        ConferenceRoomBookingDelete, ConferenceRoomBookingEdit,
        ButtonPrimary,
        FloorItem,
        DeskItem,
        AccordionItem,
        Accordion,
        Loading,
        ButtonDelete,
        ConfirmDialog,
        TailwindTable,
        Monthspicker,
        Headline,
        ButtonSecondary,
    },

    inject: ['can'],

    data: () => ({
        loading: false,
        current: '',
        schedules: [],
        previous: '',
        next: '',
        name: '',
        today: new Date().toISOString().substring(0, 10),
        roomToSwap: null,
        bookingToSwap: null,
        floors: [],
    }),

    mounted() {
        this.load();
        this.loadFloors()
    },

    filters: {
        date(date) {
            const [y, m, d] = date.split('-');

            return d + '.' + m + '.';
        },
        DATE(date) {
            const [y, m, d] = date.split('-');

            return d + '.' + m + '.' + y;
        },
    },

    methods: {
        download() {
            window.open('/admin/conference_room_schedules/export?month='+this.current);
        },
        load(date = null) {
            this.loading = true;
            this.$http.get(`/admin/conference_room_schedules${date ? '?date=' + date : ''}`)
                .then(result => {
                    this.loading = false;
                    this.schedules = result.data.schedules;
                    this.current = result.data.current;
                    this.next = result.data.next;
                    this.previous = result.data.previous;
                })
                .catch(error => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                })
        },
        async loadFloors(){
            const response = await axios.get('/admin/floors');
            this.floors = await response.data.data;
        },
        asDay(day) {
            return format(new Date(day), 'dd.MM.');
        },
        time(date) {
            return format(new Date(date), 'dd.MM.') + ' ' + date.slice(11,16)
        },
        getReadableInterval(interval){
            switch (interval){
                case "daily":
                    return "Tag(e)"
                case "weekly":
                    return "Woche(n)"
                case "monthly":
                    return "Monat(e)"
                case "yearly":
                    return "Jahr(e)"
            }
        },
    },
}
</script>

<style scoped>

</style>
